import { render, staticRenderFns } from "./PortalTableBody.vue?vue&type=template&id=0e5537bd&"
import script from "./PortalTableBody.vue?vue&type=script&lang=js&"
export * from "./PortalTableBody.vue?vue&type=script&lang=js&"
import style0 from "./PortalTableBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports